import { inEnum, isBoolean, isString } from "@ciaopeople/cp-shatsu/TypeChecking";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { MediaAudioOnPolicy, EmbeddablePlayerConfig, isEmbeddablePlayerConfig } from "@mp-commons/config/MediaPlayerConfig.js"
import { DomainConfig } from "@mp-commons/config/DomainConfig.js";
import { VideoPolicyRules } from "@mp-commons/modules/ads/vprules/VideoPolicyRules.js";


export interface MegarideEmbeddablePlayerConfig extends EmbeddablePlayerConfig {
    bar: boolean,
    viewsPlaceholder?: string,
    authorPlaceholder?: string,
    titlePlaceholder?: string,
    thumbPlaceholder?: string,
    usePreferenceQuality: boolean,
    audioOnPolicy?: MediaAudioOnPolicy,
    videoPolicy?: VideoPolicyRules,
    manualPlaylist: boolean
}


export function isMegarideEmbeddablePlayerConfig(obj: any): obj is MegarideEmbeddablePlayerConfig {
    return isEmbeddablePlayerConfig(obj) &&
        hasOwnProperty(obj, 'bar') && isBoolean(obj['bar']) &&
        hasOwnProperty(obj, 'manualPlaylist') && isBoolean(obj['manualPlaylist']) &&
        hasOwnProperty(obj, 'usePreferenceQuality') && isBoolean(obj['usePreferenceQuality']) &&
        (!hasOwnProperty(obj, 'viewsPlaceholder') || isString(obj['viewsPlaceholder'])) &&
        (!hasOwnProperty(obj, 'authorPlaceholder') || isString(obj['authorPlaceholder'])) &&
        (!hasOwnProperty(obj, 'titlePlaceholder') || isString(obj['titlePlaceholder'])) &&
        (!hasOwnProperty(obj, 'thumbPlaceholder') || isString(obj['thumbPlaceholder'])) &&
        (!hasOwnProperty(obj, 'withoutAdvertising') || isBoolean(obj['withoutAdvertising'])) &&
        (!hasOwnProperty(obj, 'audioOnPolicy') || inEnum(obj['audioOnPolicy'], MediaAudioOnPolicy)) &&
        (!hasOwnProperty(obj, 'videoPolicy') || inEnum(obj['videoPolicy'], VideoPolicyRules));

}



export interface MegaridePlayerConfig {
    domain: DomainConfig,
    embeddablePlayerConfig?: MegarideEmbeddablePlayerConfig

}

export type ComscoreLoadMode = "jit" | "lazy" | "preload"

export interface ParthenopePlayerConfig extends MegaridePlayerConfig {
    prebid?: {
        enable: boolean,
        amazon?: {
            pubID: string
        },
        ias?: {
            pubId: string,
            anId: string
        }
        timeout: number
    },
    reuseExistingVideoElement?: boolean,
    initialPoster: string,
    comscoreLoadMode?: ComscoreLoadMode,
    videoPolicy: VideoPolicyRules,
    audioOnPolicy: MediaAudioOnPolicy,
    onlyVideoPoster: boolean,
    enableStoryboard: boolean,
    withoutAdvertising?: boolean
}

export interface LigeaPlayerConfig extends MegaridePlayerConfig {
    initialPoster: string,
    videoPolicy: VideoPolicyRules,
    startWithAudioOn: boolean,
    availableContent: boolean
}

export interface LeucosiaPlayerConfig extends MegaridePlayerConfig {
    initialPoster: string,
    reuseExistingVideoElement?: boolean,
}